import { useState, useEffect } from 'react'
import { format } from 'date-fns'
import { useLazyGetDailyReportQuery } from 'orders/reduxQueries'
import { getFiltersFromUrl } from 'uiComponents/filter/filterHelpers'

export const useOrdersData = (accountSlug: string | undefined, selectedDate: Date) => {
    const [ordersCount, setOrdersCount] = useState<number>(0)
    const [fetchData] = useLazyGetDailyReportQuery()

    useEffect(() => {
        if (!accountSlug) return

        const products = getFiltersFromUrl('products').split(',').filter(Boolean)
        const apfFields = getFiltersFromUrl('apf_fields').split(',').filter(Boolean)
        const locationIds = getFiltersFromUrl('location_id')
        fetchData({
            accountSlug,
            date: format(selectedDate, 'yyyy-MM-dd'),
            products,
            apfFields,
            locationIds,
            returnTotal: true,
        })
            .unwrap()
            .then((response) => {
                setOrdersCount(response?.total || 0)
            })
            .catch((error) => {
                console.error('Error fetching order data:', error)
            })
    }, [accountSlug, selectedDate, fetchData, location.search])

    return { ordersCount }
}
